import request from '@/utils/request'
export default {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  setPageLoading({ commit }, isLoading) {
    commit('SET_PAGE_LOADING', isLoading)
  },
  setFullscreenLoading({ commit }, isLoading) {
    commit('SET_FULLSCREEN_LOADING', isLoading)
  },
  async getConfigs({ commit }) {
    return request.get('/api/configs').then(({ data }) => {
      const { configs } = data
      commit('SET_CONFIGS', configs)
    })
  },
  async updateConfigs({ dispatch }, payload) {
    return request.put('/api/admin/configs', payload).then(() => {
      dispatch('getConfigs')
    })
  },
}
